import { render, staticRenderFns } from "./RecordNavigation.vue?vue&type=template&id=1edd8380&scoped=true&"
import script from "./RecordNavigation.vue?vue&type=script&lang=js&"
export * from "./RecordNavigation.vue?vue&type=script&lang=js&"
import style0 from "./RecordNavigation.vue?vue&type=style&index=0&id=1edd8380&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edd8380",
  null
  
)

export default component.exports